"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "aci-castello": {
    "c8e35280": [{
      "hkey": "79ced831",
      "slug": "aci-castello",
      "name": "Aci Castello",
      "primary": true,
      "skipSearch": false
    }],
    "acitrezza": [{
      "hkey": "79ced831",
      "slug": "aci-castello",
      "name": "Aci Castello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "09fbed8d": [{
      "hkey": "79ced831",
      "slug": "aci-castello",
      "name": "Aci Castello",
      "primary": true,
      "skipSearch": false
    }],
    "cannizzaro": [{
      "hkey": "79ced831",
      "slug": "aci-castello",
      "name": "Aci Castello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e2417c85": [{
      "hkey": "79ced831",
      "slug": "aci-castello",
      "name": "Aci Castello",
      "primary": true,
      "skipSearch": false
    }],
    "ficarazzi": [{
      "hkey": "79ced831",
      "slug": "aci-castello",
      "name": "Aci Castello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;